module.exports = __webpack_public_path__ + "img/r2.9f3a237f.jpg";